import React from 'react';
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

import Avatar from '../shared/Avatar';
import Badge from './Badge';
import CardLabel from './CardLabel';
// eslint-disable-next-line no-restricted-imports
import { LinkWrapper } from 'common/components/singlespa/link-wrapper';
// eslint-disable-next-line no-restricted-imports
import { RouterLinkProps } from 'common/components/singlespa/router-link';

export const CardDetails = styled.div`
  display: inline-block;
  position: relative;
  background: rgba(255, 255, 255, 0.7);
  width: 100%;
  z-index: 10;
`;

export const Card = styled.div`
  background-color: ${colors.white};
  border-radius: 3px;
  box-sizing: border-box;
  box-shadow: 0 1px 0 0 ${colors.N50A};
  display: block;
  padding-bottom: 6px;
  position: relative;
  overflow: hidden;
  width: 232px;
`;

export const CardLinkWrapper = styled.span`
  > a {
    background-color: ${colors.white};
    border-radius: 3px;
    box-sizing: border-box;
    box-shadow: 0 1px 0 0 ${colors.N50A};
    display: block;
    padding-bottom: 6px;
    position: relative;
    overflow: hidden;
    width: 232px;

    text-decoration: none;
    &:hover {
      background-color: ${colors.N20};
      cursor: pointer;

      ${CardDetails} {
        background: transparent;
      }
    }
  }
`;

export const CardLink = (props: RouterLinkProps) => (
  <CardLinkWrapper>
    <LinkWrapper {...props} />
  </CardLinkWrapper>
);

interface CardStickersProps {
  height?: number;
}

export const CardStickers = styled<CardStickersProps, 'div'>('div')`
  position: relative;
  height: ${({ height }) => (height ? height : 64)}px;
  width: 100%;
`;

interface CoverProps {
  bgColor?: string;
  img: string;
  bgSize?: string;
  height: number;
}

export const CardCover = styled<CoverProps, 'div'>('div')`
  background-color: ${({ bgColor }) => (bgColor ? bgColor : 'transparent')};
  background-image: url("${({ img }) => img}");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: ${({ bgSize }) => {
    switch (bgSize) {
      case 'contain':
        return 'contain';
      case 'cover':
      default:
        return 'cover';
    }
  }};
  height: ${({ height }) => height}px;

  & + ${CardStickers} {
    position: absolute;
    top: 0;
  }
`;

export const CardTitle = styled.div`
  color: ${colors.N800};
  font-family: ${fontFamily};
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  margin: 0;
  padding: 6px 8px 0;
  word-wrap: break-word;
`;

export const CardLabels = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  max-width: 100%;
  padding: 2px 4px 0 8px;

  ${CardLabel} {
    margin-right: 4px;
    margin-top: 4px;
  }

  & + ${CardTitle} {
    padding-top: 4px;
  }
`;

export const CardBadges = styled.div`
  box-sizing: border-box;
  display: inline-block;
  float: left;
  max-width: calc(100% - 6px);
  padding-left: 6px;

  ${Badge} {
    margin-top: 4px;
    margin-right: 4px;
  }
`;

export const CardMembers = styled.div`
  box-sizing: border-box;
  display: inline-block;
  float: right;
  max-width: calc(100% - 6px);
  padding-right: 6px;

  ${Avatar} {
    margin-left: 4px;
    margin-top: 4px;
    float: right;
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/Card.tsx